import { Alert, AlertDescription } from '@volee/ui'

/** Above the fields and never a toast: an error to correct stays next to what corrects it. */
export function FormError({ message }: { message?: string }) {
  if (message === undefined) return null
  return (
    <Alert variant="destructive">
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  )
}
